"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class EnergyMasterTest extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'energyMasterTest';
        this._recipients = (0, util_1.camelArray)(initParams.recipients);
        this._site = initParams.site;
        this._siteId = initParams.site_id;
        this._forecastedStart = initParams.forecasted_start;
        this._solarProduction = (0, util_1.camelArray)(initParams.solar_production);
        this._consumption = (0, util_1.camelArray)(initParams.consumption);
        this._dataJson = initParams.data_json;
        this._flexibleConsumption = (0, util_1.camelArray)(initParams.flexible_consumption);
    }
    set recipients(value) {
        console.error('Do not set objects this way');
    }
    get recipients() {
        return this._recipients;
    }
    set site(value) {
        console.error('Do not set objects this way');
    }
    get site() {
        return this._site;
    }
    set siteId(value) {
        console.error('Do not set objects this way');
    }
    get siteId() {
        return this._siteId;
    }
    set forecastedStart(value) {
        console.error('Do not set objects this way');
    }
    get forecastedStart() {
        return this._forecastedStart;
    }
    set solarProduction(value) {
        console.error('Do not set objects this way');
    }
    get solarProduction() {
        return this._solarProduction;
    }
    set consumption(value) {
        console.error('Do not set objects this way');
    }
    get consumption() {
        return this._consumption;
    }
    set dataJson(value) {
        console.error('Do not set objects this way');
    }
    get dataJson() {
        return this._dataJson;
    }
    set flexibleConsumption(value) {
        console.error('Do not set objects this way');
    }
    get flexibleConsumption() {
        return this._flexibleConsumption;
    }
}
exports.default = EnergyMasterTest;
//# sourceMappingURL=energyMasterTest.js.map